import { ClientInfo, ProductRecommendation } from '../types';

interface SavedResults {
  id: string;
  date: Date;
  formData: any;
  recommendedProducts: ProductRecommendation[];
  bonusProducts: ProductRecommendation[];
  clientInfo: ClientInfo;
}

const COOKIE_NAME = 'pemlab_results';
const COOKIE_EXPIRY_DAYS = 30;

export class CookieService {
  static saveResults(
    formData: any,
    recommendedProducts: ProductRecommendation[],
    bonusProducts: ProductRecommendation[],
    clientInfo?: ClientInfo
  ): string {
    const resultId = this.generateResultId();
    const savedResults: SavedResults = {
      id: resultId,
      date: new Date(),
      formData,
      recommendedProducts,
      bonusProducts,
      clientInfo: clientInfo || formData.clientInfo
    };

    // Save to cookies
    const expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_EXPIRY_DAYS);
    
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(savedResults))}; expires=${expires.toUTCString()}; path=/`;
    
    return resultId;
  }

  static getResults(): SavedResults | null {
    const cookies = document.cookie.split(';');
    const resultCookie = cookies.find(cookie => cookie.trim().startsWith(`${COOKIE_NAME}=`));
    
    if (!resultCookie) return null;
    
    try {
      const value = decodeURIComponent(resultCookie.split('=')[1]);
      return JSON.parse(value);
    } catch (error) {
      console.error('Error parsing saved results:', error);
      return null;
    }
  }

  static hasResults(): boolean {
    return this.getResults() !== null;
  }

  static clearResults(): void {
    document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  private static generateResultId(): string {
    return `result_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
}
